import QRCode from "qrcode";
import { useEffect, useState } from "react";

export interface TotpEnrollment {
  secret: string;
  otpauthUri: string;
}

const QR_OPTIONS = { margin: 0, width: 320, color: { dark: "#04214c", light: "#ffffff" } };

/** Starts a TOTP enrollment once per mount; returns the secret and its QR code as a data URL as they arrive. */
export function useTotpSecret(
  start: () => Promise<TotpEnrollment>,
  onStartError?: (err: unknown) => void,
): { secret: string | null; qr: string | null } {
  const [secret, setSecret] = useState<string | null>(null);
  const [qr, setQr] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    start()
      .then(async (data) => {
        if (cancelled) return;
        setSecret(data.secret);
        const url = await QRCode.toDataURL(data.otpauthUri, QR_OPTIONS);
        if (!cancelled) setQr(url);
      })
      .catch((err: unknown) => {
        if (!cancelled) onStartError?.(err);
      });
    return () => {
      cancelled = true;
    };
    // Start exactly once per mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { secret, qr };
}
